import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import Home from "@/pages/Home";
import About from "@/pages/About";
import HowItWorks from "@/pages/HowItWorks";
import Marketplace from "@/pages/Marketplace";
import RealEstate from "@/pages/RealEstate";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import Messages from "@/pages/Messages";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { IntroSplash } from "@/components/IntroSplash";

function HomeWithIntro() {
  const [showIntro, setShowIntro] = React.useState(() => !sessionStorage.getItem("eti_intro_seen"));
  const done = () => {
    sessionStorage.setItem("eti_intro_seen", "1");
    setShowIntro(false);
  };
  return (
    <>
      {showIntro && <IntroSplash onEnter={done} />}
      <Layout><Home /></Layout>
    </>
  );
}

function IntroPage() {
  const navigate = useNavigate();
  return <IntroSplash onEnter={() => { sessionStorage.setItem("eti_intro_seen", "1"); navigate("/"); }} />;
}

function Layout({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-16 lg:pt-[70px]">{children}</main>
      <Footer />
    </div>
  );
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomeWithIntro />} />
      <Route path="/intro" element={<IntroPage />} />
      <Route path="/about" element={<Layout><About /></Layout>} />
      <Route path="/how-it-works" element={<Layout><HowItWorks /></Layout>} />
      <Route path="/marketplace" element={<Layout><Marketplace /></Layout>} />
      <Route path="/real-estate" element={<Layout><RealEstate /></Layout>} />
      <Route path="/pricing" element={<Layout><Pricing /></Layout>} />
      <Route path="/contact" element={<Layout><Contact /></Layout>} />
      <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />
      <Route path="/profile" element={<Layout><Profile /></Layout>} />
      <Route path="/profile/:userId" element={<Layout><Profile /></Layout>} />
      <Route path="/messages" element={<Layout><Messages /></Layout>} />
      <Route path="/admin" element={<Layout><Admin /></Layout>} />
      <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
      <Route path="/payment/cancel" element={<Layout><PaymentCancel /></Layout>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
        <Toaster position="top-right" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
